{
  "instances": {
    "logfile": {
      "label": "Archivo de log",
      "download": "Descargar",
      "wrap_lines": "Ajustar líneas",
      "page_up": "Subir página",
      "page_down": "Bajar página",
      "previous_chunk": "Fragmento anterior",
      "next_chunk": "Fragmento siguiente",
      "resume_follow": "Reanudar seguimiento",
      "stop_follow": "Detener seguimiento",
      "reconnecting": "Reconectando...",
      "compressed_reset": "Archivo de registro comprimido, restableciendo la página"
    }
  }
}
